<app-invoices-table
  #invoiceTable
  [loadInvoices]="loadInvoices"
  [recurrent]="false"
  (onViewEdit)="onView($event, false)"
  [patientView]="true"
></app-invoices-table>